import React from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';

import { getCookie } from 'utils';
import { RiskFlow } from 'types/RiskControl';
import { RiskMotorFlow } from './RiskMotorFlow';
import '@frete.com/fuel-fonts/satoshi/fontface.css';

export const App = () => {
  const risk = parseInt(process.env.RISK_FLOW, 10);

  const mockOutletContext = {
    riskFlow: {
      data: {
        freightId: '',
        freightRisk: risk,
        isHighRisk: [3, 4].includes(risk),
      },
      hadSuccess: false,
      hadError: false,
      riskProcessed: false,
    },
    setRiskFlow: (state: RiskFlow) => state,
  };

  const isAuthenticated = getCookie('_TOKEN_BFF');

  if (!isAuthenticated) window.location.assign(process.env.FRETEBRAS_LOGIN_URL);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Outlet context={mockOutletContext} />}>
          <Route path="/" element={<RiskMotorFlow />} />
        </Route>
        <Route path="healthcheck">
          <Route
            path="readiness"
            element={<>{'{message:Readiness! called /health/readiness}'}</>}
          />
          <Route
            path="liveness"
            element={<>{'{message:Liveness! called /health/liveness}'}</>}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
